import type { Partner } from "@expert/shared-types";

import type { ChannelShareData } from "../customer-info/types";

export function shouldShowCallIntroFlowQuestions(_partner: Partner, _callDetails: ChannelShareData): boolean {
    return true;
}
